<mat-icon
  class="payever-icon"
  svgIcon="santander-short"
></mat-icon>
